import {
  IonContent,
  IonHeader,
  IonPage,
  useIonViewWillEnter,
} from "@ionic/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FeedItem } from "../components/Feed/FeedItem";
import CommentForm from "../components/form/CommentForm";
import Header from "../components/layout/Header";
import { getPostById } from "../redux/actions/postActions";
import SkeletonPost from "./SkeletonPost/SkeletonPost";
import { Helmet } from "react-helmet-async";

function Post() {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const post = useSelector((state) => state.post);
  const { postById, newPost, newRepost, modifiedPost, error, loadingPostById } =
    post;

  useIonViewWillEnter(() => {
    dispatch(getPostById(id));
  }, [dispatch, id]);

  // useEffect(() => {
  //   if (newPost || newRepost) {
  //     dispatch(getPostById(id));
  //   }
  // }, [dispatch, id, newPost, newRepost]);
  // Not working yet
  if (error?.status === 403) {
    return (
      <IonPage>
        <Header />
        <IonContent className="ion-padding ion-text-center">
          <div style={{ marginTop: "20%" }}>
            <h2>🔒 Private Content</h2>
            <p>You need an invite to view this community.</p>
          </div>
        </IonContent>
      </IonPage>
    );
  }
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>
        <IonContent>
          {loadingPostById || !postById ? (
            <SkeletonPost />
          ) : (
            <div>
              <FeedItem post={postById} />
              <CommentForm post={postById} />
              <div className="post__replies header-font">{t("replies")}</div>
              {postById.replies.map((comment) => (
                <FeedItem key={comment._id} post={comment} />
              ))}
            </div>
          )}
        </IonContent>
      </IonPage>
    </>
  );
}

export default Post;
